import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMxx3haQ0T_6knK8HytzV6WL7duUAHlbg",
  authDomain: "atelier-persopol-2.firebaseapp.com",
  projectId: "atelier-persopol-2",
  storageBucket: "atelier-persopol-2.firebasestorage.app",
  messagingSenderId: "585390382550",
  appId: "1:585390382550:web:d1df89186c1b2141dfd877",
  measurementId: "G-M2N89WF4FR"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Analytics removed to prevent initialization errors
